import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { kisiQueryKeys } from "./kisiQueryKeys";

export function useMutationKisiGenerateSignatureKey({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await api.kisiApi.generateSignatureKey()).data,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: kisiQueryKeys.brandConfig(),
      });
    },
  });
}
